module.exports = __webpack_public_path__ + "img/img4_4.44c5dec9.jpeg";